import { Box, Container, Heading, Icon, Spinner, Text, VStack } from '@chakra-ui/react'
import React, { useContext, useState, useEffect } from 'react'
import Navbar from '../compnents/Navbar'
import SideBar from '../compnents/SideBar'
import Footer from '../compnents/Footer'
import AuthContext from '../context/AuthContext';
import ThemeContext from '../context/ThemeContext';
import axios from 'axios';
import SettingsEmployeeManagementFree from './SettingsPages/SettingsEmployeeManagementFree'
import SettingsEmployeeManagementPaid from './SettingsPages/SettingsEmployeeManagementPaid'
import UploadYourFile from './UploadYourFile'
import Loading from '../compnents/Loading'
import FeatureUnlockContext from '../context/FeatureUnlockContext'
import SettingsCustomerListPaid from './SettingsPages/SettingsCustomerListPaid'
import { FaShieldAlt } from 'react-icons/fa'

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;

function Settings() {
    const { token, user, setUser, logout } = useContext(AuthContext);
    const { themeData } = useContext(ThemeContext);
    const { resetUnlocks } = useContext(FeatureUnlockContext);
    const [loading, setLoading] = useState(true);

    const [customers, setCustomers] = useState([]);
    const [loadingCustomers, setLoadingCustomers] = useState(true);
    // Determine if theme is dark (midnight)
    const isDarkTheme = themeData?.id === 'midnight';

    // Extract theme colors with fallbacks
    const bodyTextColor = isDarkTheme ? '#E2E8F0' : 'gray.600';
    const mutedTextColor = isDarkTheme ? '#CBD5E0' : 'gray.500';
    const primaryColor = themeData?.colors?.primary || '#2B6CB0';
    const headingTextColor = isDarkTheme ? '#F7FAFC' : primaryColor;
    const backgroundColor = themeData?.colors?.background || '#F7FAFC';

    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const res = await axios.get(`${API_BASE_URL}/content/list-customers?page=1&page_size=10`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setCustomers(res.data.customers.slice(0, 7)); // ensure top 7 only
            } catch (err) {
                console.error("Error fetching customers:", err);
            } finally {
                setLoadingCustomers(false);
            }
        };

        if (user?.subscription !== 'free' && user?.role === 'admin') {
            fetchCustomers();
        }
    }, [token, user]);

    useEffect(() => {
        const fetchUser = async () => {
            if (!token || user) {
                setLoading(false);
                return;
            }

            try {
                const res = await axios.get(`${API_BASE_URL}/auth/check-user`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                console.log("checking user: ", res);

                if (res.status === 420) {
                    console.error('Invalid token');
                    resetUnlocks();
                    logout();
                    return;
                }

                setUser(res.data);
            } catch (error) {
                console.error('Error fetching user:', error);
                if (error.response?.status === 420) {
                    console.error('Token expired or invalid, logging out...');
                    resetUnlocks();
                    logout();
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [token, user, setUser, logout, resetUnlocks]);

    if (!token || (!user && loading)) {
        return (
            <Loading />
        );
    }

    if (!user) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center" bg={backgroundColor}>
                <Spinner size="xl" color={primaryColor} />
            </Box>
        );
    }

    if (user && user.noOfFileUploads === 0) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column" bg={backgroundColor}>
                <Navbar />

                <UploadYourFile setUser={setUser} token={token} />
            </Box>
        )
    }

    // Check if user has access
    const hasAccess = user.subscription === 'business' &&
        (user.role === 'admin');

    if (!hasAccess) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column">
                <Navbar />
                <Box display="flex" flex="1" bg={backgroundColor}>
                    <SideBar />
                    <Container maxW="container.xl" flex="1" py={8}>
                        <VStack spacing={6} align="center" justify="center" minH="60vh">
                            <Icon as={FaShieldAlt} boxSize={16} color={mutedTextColor} />
                            <Heading size="lg" color={headingTextColor}>
                                Settings and Employee Creation
                            </Heading>
                            <Text color={bodyTextColor} textAlign="center">
                                This feature is only available for Business subscription users with higher access than yours.
                            </Text>
                        </VStack>
                    </Container>
                </Box>
                <Footer />
            </Box>
        );
    }

    return (
        <Box minH="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box display="flex" flex="1" bg={backgroundColor}>
                <SideBar />
                <Container maxW="container.xl" flex="1">
                    {/*<VStack spacing={6} >
                        <Flex justify="space-between" align="center">
                            <Box>
                                <Heading size="lg" mb={1} p={1} bgGradient="linear(to-r, purple.400, pink.400)" bgClip="text">
                                    Settings
                                </Heading>
                            </Box>
                        </Flex>
                    </VStack>*/}

                    <VStack spacing={6} align="stretch">
                        {((user.subscription === 'free') && (user.role === 'admin' || user.role === 'rm')) && (
                            <SettingsEmployeeManagementFree />
                        )}
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'admin')) && (
                            <>
                                <SettingsEmployeeManagementPaid />
                                <SettingsCustomerListPaid customers={customers} loadingCustomers={loadingCustomers} />
                            </>
                        )}
                    </VStack>
                    {/* This is shifted to Dashboard.js */}
                    {/* <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'rm')) && (
                            <>
                                <SettingsRMownBookPaid />
                                <SettingsRMwhoToCallPaid />
                                <SettingsRMpriorityScores />
                                <SettingsRMriskRanking />
                                <SettingsRMsegments />
                            </>
                        )}
                    </VStack> */}

                </Container>
            </Box>
            <Footer />
        </Box>
    )
}

export default Settings